import {
  createContext,
  useContext,
  useState
} from "react";

const LanguageContext = createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

export function LanguageProvider({children}) {
  const [currentLanguage, setCurrentLanguage] = useState("Korean");

  const value = {
    currentLanguage,
    setCurrentLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      { children }
    </LanguageContext.Provider>
  )
}
